import { render, staticRenderFns } from "./Institutional.vue?vue&type=template&id=af0ff932&scoped=true&"
import script from "./Institutional.vue?vue&type=script&lang=js&"
export * from "./Institutional.vue?vue&type=script&lang=js&"
import style0 from "./Institutional.vue?vue&type=style&index=0&id=af0ff932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0ff932",
  null
  
)

export default component.exports